// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-48311e6c]{margin-top:15px}.divInfo[data-v-48311e6c]{margin:15px 0 1px 0;font-family:DINPro;font-size:12px;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.09px;color:#555}.divAddPlan[data-v-48311e6c]{margin-bottom:15px}.rigth[data-v-48311e6c]{float:right}", ""]);
// Exports
module.exports = exports;
